import { useEffect } from "react";
import { I2cButton, I2cIcon } from "@webcomponents/i2cwebcomponents/dist/react";
import React, { useRef } from "react";
import SignatureCanvas from "react-signature-canvas";
import { UserStateContext } from "../../../Context/AuthContext";

const SignatureBox = ({ onEnd, value }) => {
  const signatureRef = useRef(null);
  const { darkMode, setDarkMode } = UserStateContext();
  useEffect(() => {
    if (darkMode) {
      signatureRef.current.clear();
    }
  }, [darkMode]);

  useEffect(() => {
    if (value) {
      signatureRef.current.fromDataURL(value);
    }
  }, []);

  const handleClear = () => {
    signatureRef.current.clear();
  };
  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "calc(var(--i2c-spacing-40) + var(--i2c-spacing-0-5))",
      }}
    >
      <SignatureCanvas
        penColor={`${darkMode ? "#ffffff" : "#000000"}`}
        canvasProps={{
          className: "sigCanvas",
          style: {
            border: "1px solid var(--border-secondary)",
            width: "100%",
            height: "calc(var(--i2c-spacing-40) + var(--i2c-spacing-0-5))",
          },
        }}
        onEnd={(e) => {
          const signatureData = signatureRef.current.toDataURL();
          onEnd(signatureData);
        }}
        ref={signatureRef}
      />
      <I2cIcon
        onClick={handleClear}
        style={{
          position: "absolute",
          right: "var(--i2c-spacing-1-5)",
          top: "var(--i2c-spacing-1-5)",
        }}
        name="bulk-close-circle"
      />
    </div>
  );
};

export default SignatureBox;
